import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from './services/appInsightsService'
import AppInsightsErrorBoundary from './config/AppInsightsErrorBoundary';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <AppInsightsContext.Provider value={reactPlugin}>
            <AppInsightsErrorBoundary appInsights={appInsights}>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <HelmetProvider>
                        <App />
                    </HelmetProvider>
                </BrowserRouter>
            </AppInsightsErrorBoundary>
        </AppInsightsContext.Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
